var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"experiences"},_vm._l((_vm.experiences),function(experience){return _c('experience',{key:experience.id,ref:_vm.experiences,refInFor:true,attrs:{"jobTitle":experience.jobTitle,"company":experience.company,"dateRange":experience.dateRange,"path":experience.path,"imageAlt":experience.alt}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }